import {setupNetworkMonitor} from '../../libs/shared/core/src/services/network/networkMonitor';

export function setupFrontNetworkMonitor() {
  setupNetworkMonitor('/api/1/noauth/ping');
}
